import React from 'react';
import '../styles/MobileFooter.css'; // Link to our separate CSS file
import { Link, useNavigate } from 'react-router-dom';
import home from "../assets/images/home.png"
import shop from "../assets/images/shop.png"
import order from "../assets/images/order.png"
import call from "../assets/images/call.png"
const MobileFooter = ({ petId }) => {
      const navigate = useNavigate();

    const handleWhatsAppRedirect = () => {
        const phoneNumber = '917019272992';
        const message = "Hi, I'm interested in purchasing your products. Could you please share more details?"
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank'); // Opens WhatsApp in new tab
    };
    const goToSectionProduct = () => {
        navigate('/', { state: { scrollToId: 'productFilter' } });
    };

    return (
        <footer className="sticky-footer-pedigree">
            <div>
                <Link to="/" className="footer-icon">
                    <img src={home} alt="Scan" />
                    <span>Home</span>
                </Link>
            </div>
            <div onClick={goToSectionProduct}  className="footer-icon">
               
                <img src={shop} alt="All" />
                <span>Shop</span>

            </div>
            <div>
                <div onClick={handleWhatsAppRedirect} className="footer-icon">
                    <img src={order} alt="bulk" />
                    <span>Bulk Order</span>
                </div>
            </div>
            <div>
                <Link to='/contact-us' className="footer-icon">
                    <img src={call} alt="contact" />
                    <span>Contact</span>
                </Link>
            </div>
        </footer>
    );
};

export default MobileFooter;